import { ref } from "vue";
import { defineStore } from "pinia";
import type { ResultCode } from "@adyen/adyen-web";

/**
 * Store for managing Adyen-specific state, such as loading the Adyen SDK,
 * storing tokenised card IDs, and tracking tokenisation status.
 * This store is designed to be used in conjunction with the main checkout
 * store to handle payment processing with Adyen.
 */
export const useAdyenStore = defineStore(
    "adyen",
    () => {
        const loadAdyenSDK = ref<boolean>(false);
        const tokenisedCardId = ref<string | null>(null);
        const tokenisationStatus = ref<ResultCode | null>(null);
        const isPaymentActionInProgress = ref<boolean>(false);

        function setLoadAdyenSDK(load: boolean) {
            loadAdyenSDK.value = load;
        }

        function setTokenisedCardId(id: string | null) {
            tokenisedCardId.value = id;
        }

        function setTokenisationStatus(status: ResultCode | null) {
            tokenisationStatus.value = status;
        }

        function setIsPaymentActionInProgress(value: boolean) {
            isPaymentActionInProgress.value = value;
        }

        return {
            loadAdyenSDK,
            tokenisedCardId,
            tokenisationStatus,
            isPaymentActionInProgress,
            setLoadAdyenSDK,
            setTokenisedCardId,
            setTokenisationStatus,
            setIsPaymentActionInProgress,
        };
    },
    {
        persist: {
            pick: ["loadAdyenSDK", "tokenisedCardId", "tokenisationStatus"],
            storage: sessionStorage,
        },
    },
);
